module.exports = __webpack_public_path__ + "img/psyz2sp4jln4t9d6lzfo4zyqe5uaxieo3pobaae1c86-82a1-4f58-a56a-2a2e2ed4c5c3.9bc4a1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/psyz2sp4jln4t9d6lzfo4zyqe5uaxieo3pobaae1c86-82a1-4f58-a56a-2a2e2ed4c5c3.png
// module id = xgso
// module chunks = 1